import { BusinessHealthResponse } from '../../../types';

const getStatusForComponent = (
    componentKey: string,
    data?: BusinessHealthResponse,
) => data?.healthscore?.components?.[componentKey]?.status;

export default getStatusForComponent;
